import Dashboard from 'components/Dashboard/Dashboard';
import Reports from 'components/Reports/Reports';
import Research from 'components/Research/Research';
import FactSheets from 'components/Factsheets/FactSheets';
import Organisations from 'components/Admin/orgs/Organisations';
import Banks from 'components/Admin/banks/Banks';
import CurrencyBooks from 'components/CurrencyBooks/CurrencyBooks';
import AdminAppUsers from 'components/Admin/users/AppUsers';
import AdminManageResearch from 'components/Admin/research/AdminManageResearch';
import UploadBalance from 'components/Admin/upload/UploadBalance';
import Settings from 'components/Settings/Settings';
import { Authenticator } from 'components/Auth/Authenticator';
import ErrorPage from 'components/ErrorPage';
import ViewBusinessUnit from 'components/ViewBusinessUnit/ViewBusinessUnit';
import { CreateBusinessUnit } from 'components/ViewBusinessUnit/CreateBusinessUnit';
import { routeMap } from 'routeMap';
import ViewBankAccount from 'components/ViewBankAccount/ViewBankAccount';
import ViewBalances from 'components/ViewBalances/ViewBalances';
import AdminViewBankAccounts from 'components/AdminViewBankAccounts/AdminViewBankAccounts';
import { CreateBankAccount } from 'components/AdminViewBankAccounts/CreateBankAccount';

export default [
  {
    path: [routeMap.root(), routeMap.home()],
    component: Dashboard,
    exact: true,
    authenticatedOnly: true,
  },
  {
    path: routeMap.authenticatorRoot(),
    component: Authenticator,
    unauthenticatedOnly: true,
  },
  {
    path: routeMap.confirmSignUp(),
    component: Authenticator,
    unauthenticatedOnly: true,
  },
  { path: routeMap.reports(), component: Reports, authenticatedOnly: true },
  { path: routeMap.research(), component: Research, authenticatedOnly: true },
  {
    path: routeMap.factsheets(),
    component: FactSheets,
    authenticatedOnly: true,
  },
  { path: routeMap.books(), component: CurrencyBooks, authenticatedOnly: true },
  { path: routeMap.settings(), component: Settings, authenticatedOnly: true },
  { path: routeMap.viewOrgs(), component: Organisations, adminOnly: true },
  {
    path: routeMap.createBusinessUnit(),
    component: CreateBusinessUnit,
    adminOnly: true,
  },
  {
    path: routeMap.viewBusinessUnit(),
    component: ViewBusinessUnit,
    adminOnly: true,
  },
  { path: routeMap.viewBanks(), component: Banks, adminOnly: true },
  { path: routeMap.viewUsers(), component: AdminAppUsers, adminOnly: true },
  {
    path: routeMap.adminResearch(),
    component: AdminManageResearch,
    adminOnly: true,
  },
  {
    path: routeMap.adminUploadBalances(),
    component: UploadBalance,
    adminOnly: true,
  },
  {
    path: routeMap.adminViewBalances(),
    component: ViewBalances,
    adminOnly: true,
  },
  {
    path: routeMap.createBankAccount(),
    component: CreateBankAccount,
    adminOnly: true,
  },
  {
    path: routeMap.viewBankAccountById(),
    component: ViewBankAccount,
  },
  {
    path: routeMap.adminViewBankAccounts(),
    component: AdminViewBankAccounts,
    adminOnly: true,
  },
  { path: routeMap.error(), component: ErrorPage },
] as any;
